import get_title from "@/router/module/get_title";
import ProductEdit from "./edit";
import NewProduct from "./new";
import validate_role from "@/router/module/validate_role";

export default [
  {
    path: "/content/nomenclature",
    name: "product__listing",
    component: () => import("@/new/pages/nomenclature"),
    meta: {
      title: get_title("Номенклатура"),
      forVisitors: true,
      requiresAuth: true
    },
    children: [NewProduct],
    beforeEnter: (to, from, next) => {
      const options = {
        role: "products.show-list",
        route: { to, from, next },
        callback: false,
        redirectText: "У вас нет доступа к разделу с номенклатурой!",
      };
      validate_role(options);
    },
  },
  ProductEdit,
];
